import { FC, ReactNode, useState } from "react";
import { twMerge } from "tailwind-merge";

import { ChevronDownIcon, ChevronUpIcon } from "mds/icons";

interface AccordionListProps {
  className?: string;
  title: string;
  titleClassName?: string;
  children: ReactNode[];
  startOpen?: boolean;
  titleRightContent?: ReactNode;
  emptyContent?: ReactNode;
  color?: "default" | "blue" | "red";
  expandableAnywhere?: boolean;
}

const colorClasses: Record<AccordionListProps["color"], string> = {
  default: "border border-black-tint-90 bg-white",
  blue: "border border-blue-tint-70 bg-blue-tint-95",
  red: "border border-red-tint-70 bg-red-tint-95",
};

export const AccordionList: FC<AccordionListProps> = ({
  className,
  title,
  children,
  emptyContent,
  startOpen = false,
  titleRightContent,
  titleClassName,
  color = "default",
  expandableAnywhere,
}) => {
  const [expanded, setExpanded] = useState(startOpen);
  const icon = expanded ? <ChevronUpIcon /> : <ChevronDownIcon />;
  return (
    <div
      className={twMerge(
        "accordion-list rounded-lg border border-black-tint-97 bg-black-tint-97 p-2",
        expanded && colorClasses[color],
        expandableAnywhere && "cursor-pointer",
        className,
      )}
      onClick={expandableAnywhere ? () => setExpanded(!expanded) : undefined}
    >
      <div
        className="flex cursor-pointer items-center justify-between"
        onClick={!expandableAnywhere ? () => setExpanded(!expanded) : undefined}
      >
        <div
          className={twMerge(
            "ml-1 flex items-center gap-2 text-sm font-medium text-black-tint-20",
            titleClassName,
          )}
        >
          {title}
          {icon}
        </div>
        {titleRightContent}
      </div>

      {expanded && (
        <div className="mt-2.5 flex flex-col">
          {children.length === 0 && emptyContent ? emptyContent : children}
        </div>
      )}
    </div>
  );
};
